type Language = 'en-US' | 'ja-JP';

export const AVAILABLE_LANGUAGES: Language[] = ['en-US', 'ja-JP'];

export const toLanguage = (value: string): Language => {
  if (value === 'en-US' || value === 'ja-JP') {
    return value;
  }

  throw new Error();
};

export default Language;
